export function toHash(array) {
  if (!Array.isArray(array)) return null
  const hash = {}
  array.forEach(i => hash[i.id] = i)
  return hash
}
